import { cn } from "@/lib/utils";

export const Eyebrow = ({ children, className, tone = "teal" }) => (
  <span
    className={cn(
      "eyebrow inline-flex items-center gap-2",
      tone === "teal" ? "text-[color:var(--bp-teal)]" : "text-[color:var(--bp-gold)]",
      className
    )}
  >
    <span
      aria-hidden
      className={cn(
        "inline-block h-px w-7",
        tone === "teal" ? "bg-[color:var(--bp-teal)]" : "bg-[color:var(--bp-gold)]"
      )}
    />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, intro, align = "left", tone = "dark", className, eyebrowTone = "teal" }) => {
  const light = tone === "light";
  return (
    <div
      className={cn(
        "max-w-2xl",
        align === "center" && "mx-auto text-center",
        className
      )}
    >
      {eyebrow && (
        <div className={cn(align === "center" && "flex justify-center")}>
          <Eyebrow tone={eyebrowTone}>{eyebrow}</Eyebrow>
        </div>
      )}
      {title && (
        <h2
          className={cn(
            "mt-5 font-display text-3xl font-semibold leading-[1.12] tracking-[-0.01em] sm:text-4xl lg:text-[2.9rem]",
            light ? "text-[color:var(--bp-text-on-light)]" : "text-[color:var(--bp-cream)]"
          )}
        >
          {title}
        </h2>
      )}
      {intro && (
        <p
          className={cn(
            "mt-5 text-[15px] leading-[1.75] sm:text-base",
            light ? "text-[color:var(--bp-text-body-on-light)]" : "text-[color:var(--bp-text-muted)]"
          )}
        >
          {intro}
        </p>
      )}
    </div>
  );
};

export const Container = ({ children, className }) => (
  <div className={cn("container-bp", className)}>{children}</div>
);
